import {
    resetFormValues,
    setApproved,
    setError,
    setIsEditCertificateModalOpen,
    setIsPatchEditCertificateSuccess,
    setSelectedCertificateId,
} from "../EditCertificateModalSlice";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { getBase64 } from "../../../common/utils/fileToBase64";
import { ErrorInterface } from "../../../common/interfaces/ErrorInterface";
import { Dispatch } from "redux";
import { toast } from "react-toastify";

interface HandleEditCertificateProps {
    certificate: CertificateInterface;
    formValues: {
        qualification: {
            selectedId: string;
            selectedValue: string;
            inputValue: string;
        };
        employee: {
            selectedId: string;
            selectedValue: string;
            inputValue: string;
        };
        educator: {
            selectedId: string;
            selectedValue: string;
            inputValue: string;
        };
        validAt: string;
        expiresAt: string;
    };
    dispatch: Dispatch;
    patchEditCertificate: (params: {
        id: number;
        data: Record<string, unknown>;
    }) => { unwrap: () => Promise<unknown> };
    file: File | null;
    approved?: boolean;
}

export const handleEditCertificate = async (
    props: HandleEditCertificateProps,
): Promise<void> => {
    const {
        certificate,
        formValues,
        dispatch,
        patchEditCertificate,
        file,
        approved,
    } = props;
    const fileFields: Record<string, unknown> = {};
    if (file?.name) {
        fileFields.certificate = await getBase64(file);
        fileFields.file_name = file.name;
    }

    const data: Record<string, unknown> = {
        qualification_id: formValues?.qualification?.selectedId,
        employee_id: formValues?.employee?.selectedId,
        educator_id: formValues?.educator?.selectedId,
        valid_at: formValues?.validAt,
        expires_at: formValues?.expiresAt || null,
        ...fileFields,
    };

    if (approved !== undefined) {
        data.approved = approved;
    }

    try {
        await patchEditCertificate({
            id: certificate.id,
            data,
        }).unwrap();
        dispatch(setError(null));
        dispatch(setApproved(undefined));
        dispatch(setIsPatchEditCertificateSuccess(true));
        dispatch(setIsEditCertificateModalOpen(false));
        dispatch(resetFormValues());
        dispatch(setSelectedCertificateId(undefined));

        toast.success(
            "Certificaat " +
                formValues.qualification.selectedValue +
                " is bijgewerkt voor " +
                formValues.employee.selectedValue,
        );
    } catch (error) {
        const errorData = error as ErrorInterface;
        dispatch(setError(errorData.data.message));
    }
};
